import { EventUsers } from "../../models/events";
import { BanStatus, User } from "../../models/users";

export function sortUsersByPaidStatus(users: EventUsers[] | undefined) {
    return users?.sort((a: { paid: number; }, b: { paid: number; }) => b.paid - a.paid);
  }

type BanAware = Pick<User, "banned" | "banStatus"> | (Pick<EventUsers, "banned"> & { banStatus?: string | null });

export function normalizeBanStatus(status?: string | null): BanStatus {
  if (!status) return "NONE";
  if (status === "NONE" || status === "REVERSIBLE") {
    return status;
  }
  return "NONE";
}

export function isUserRestrictedByBan(user?: BanAware | null): boolean {
  if (!user) return false;
  const normalizedStatus = normalizeBanStatus(user.banStatus);
  return Boolean(user.banned) || normalizedStatus === "REVERSIBLE";
}

export function getBanStatusLabel(status?: string | null): string {
  const normalizedStatus = normalizeBanStatus(status);
  if (normalizedStatus === "REVERSIBLE") return "Baneo Reversible";
  return "Sin restricción";
}